/* eslint-disable import/first, camelcase */
const devServer = process.env.DEV_SERVER;
if (!devServer) {
  __webpack_public_path__ = window.base + 'dist/';
}

import 'core-js/stable'
import './css/site.css'
import { app, siteDown } from './app'
import getConfigs from './configs'

getConfigs()
  .then(() => app.$mount('#mainapp'))
  .catch(() => siteDown.$mount('#mainapp'));
